import { render, staticRenderFns } from "./CurrencyVaration.vue?vue&type=template&id=12595c1f"
import script from "./CurrencyVaration.vue?vue&type=script&lang=js"
export * from "./CurrencyVaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports